import { message, Popover } from "antd"
import { useEffect, useRef, useState } from "react"
import { SidebarButton } from "../sidebar-button"
import { useFormikContext } from "formik"
import { TaskFormObject } from "@timenotes/shared/src/services/tasks/hooks/use-task-formik"
import minutesToDurationString from "@timenotes/shared/src/utils/converters/minutes-to-duration-string"
import OutsideAlerter from "components/view-utils/outside-alerter"
import DurationInput from "components/timenotes/time-logs/duration-input"
import useNoInitialEffect from "hooks/useNoInitialEffect"

interface Props {}

export const TaskEstimatedTimePopover = (props: Props) => {
  const inputRef = useRef()

  const formik = useFormikContext<TaskFormObject>()
  const task = formik.values

  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (visible) {
      if (inputRef.current) inputRef.current.focus()
      setTimeout(() => {
        if (inputRef.current) inputRef.current.focus()
      }, 300)
    } else {
      // Submit form if its not submiting and visible changes to false while time estimation changed
      if (!formik.isSubmitting && formik.values.timeEstimateDuration !== formik.initialValues.timeEstimateDuration) {
        formik.submitForm()
      }
    }
  }, [visible])

  useEffect(() => {
    if (formik.errors.timeEstimateDuration) {
      formik.setFieldValue('timeEstimateDuration', formik.initialValues.timeEstimateDuration)
      message.error(formik.errors.timeEstimateDuration)
    }
  }, [formik.errors.timeEstimateDuration])

  // Hide the popover on the end of formik submitting no matter if success or not
  // as errors are handled as message error globally
  useNoInitialEffect(() => {
    if (!formik.isSubmitting) {
      setVisible(false)
    }
  }, [formik.isSubmitting])

  return (
    <>
      <OutsideAlerter
        onClick={() => {
          setVisible(false)
        }}
      >
        <Popover
          getPopupContainer={(el) => el}
          visible={visible}
          placement="bottom"
          destroyTooltipOnHide
          content={(
            <>
              <DurationInput
                style={{
                  width: '200px',
                }}
                onKeyDown={(e) => {
                  if (e.key == 'Escape') {
                    e.preventDefault()
                    e.stopPropagation()

                    formik.setFieldValue('timeEstimateDuration', formik.initialValues.timeEstimateDuration)
                    setVisible(false)
                  }

                  // Just hide and actually trigger the submit by that
                  if (e.key == 'Enter') {
                    e.preventDefault()
                    e.stopPropagation()

                    setVisible(false)
                  }
                }}
                ref={inputRef}
                getPopupContainer={(el) => el}
                value={task.timeEstimateDuration || 0}
                onChange={(value) => {
                  formik.setFieldValue('timeEstimateDuration', value)
                }}
              />
            </>
          )}
        >
          <div
            onClick={() => setVisible((v) => !v)}
          >
            <SidebarButton>
              Estimated Time
            </SidebarButton>
          </div>
        </Popover>
      </OutsideAlerter>

      <div
        style={{
          marginLeft: '8px',
        }}
      >
        { task.timeEstimateDuration ? (
          <>
            { minutesToDurationString(task.timeEstimateDuration) }
          </>
        ) : (
          <span>
            No task estimate
          </span>
        )}
      </div>

    </>
  )
}